import fr from 'facet-rest';
import { fullDate } from 'Consts/DateFormats';
import moment from 'moment';

const fieldsToHide = [
  'serviceLevel',
  'assetsUnderManagement',
  'paymentMethod',
  'paymentSchedule',
  'anniversaryDate',
  'csManagerFullName',
  'status',
  'householdIncome',
];

// eslint-disable-next-line import/prefer-default-export
export const ClientExperienceSavesEscalatedHouseholdsOverride = fr.metaOverride()
  .overrideAll({ _hideLabel: true })
  .nameOverride(fieldsToHide, { hidden: true })
  .nameOverride('householdId', { ordinal: 0 })
  .nameOverride('primaryClientFullName', { ordinal: 1 })
  .nameOverride('leadPlannerFullName', { ordinal: 2 })
  .nameOverride('saveAgentFullName', { ordinal: 3 })
  .nameOverride('escalationTime', {
    ordinal: 4,
    _exportFunction: () => (v) => moment.utc(v).format(fullDate),
  }, { ordinal: 200 })
  .nameOverride('escalatedReason', { ordinal: 5 });
